import React, { useEffect, useRef, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { createSession } from '../utils/liveApi';

export default function LiveCreateSessionPage() {
  const { user } = useAuth();
  const navigate = useNavigate();
  const [error, setError] = useState(null);
  const startedRef = useRef(false); // guard against React 18 StrictMode double-effect

  // In dev, fall back to a default email so the flow works without auth.
  const animatorEmail =
    user?.email ||
    (process.env.NODE_ENV === 'development' ? 'dev-animator@localhost' : null);

  useEffect(() => {
    // startedRef survives the StrictMode unmount-remount, so this fires
    // exactly once per real navigation to /live/new. We deliberately do
    // NOT add an `alive` guard around the .then() — StrictMode's synthetic
    // unmount would flip it to false and the navigate would never happen
    // even though the API has already created the session. navigate() and
    // setError after unmount are safe under React 18 (no setState warning).
    if (startedRef.current) return;
    if (!animatorEmail) return;
    startedRef.current = true;

    createSession({ quizId: 'orientation-axis-v1', animatorEmail })
      .then((data) => {
        navigate(`/live/animator/${data.code}`, { replace: true });
      })
      .catch((e) => {
        setError(e.response?.data?.error || e.message || 'Erreur inconnue');
      });
  }, [animatorEmail, navigate]);

  if (error) {
    return (
      <div className="container" style={{ marginTop: '2rem' }}>
        <h2>Impossible de créer la session</h2>
        <p style={{ color: '#c0392b' }}>{error}</p>
        <Link to="/live" className="btn btn-secondary">Retour</Link>
      </div>
    );
  }

  return (
    <div className="container" style={{ marginTop: '2rem', textAlign: 'center' }}>
      <div className="loading">Création de la session…</div>
    </div>
  );
}
